import "babel-polyfill";
import "es6-promise/auto";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import "@/styles/common.scss";
import "element-ui/lib/theme-chalk/index.css";
import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/ko";
import axios from "axios";
import VueApexCharts from "vue-apexcharts";

Vue.config.productionTip = false;
Vue.use(ElementUI, { locale });
Vue.component("apexchart", VueApexCharts);

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("accesstoken");

  if (token) {
    config.headers.authorization = token;
  }
  return config;
});

new Vue({
  router,
  store,
  beforeCreate() {
    const token = localStorage.getItem("accesstoken");
    if (token) {
      this.$store.commit("LOGIN", token);
      this.$store.dispatch("getAccountInfo");
    }
  },

  render: (h) => h(App),
}).$mount("#app");
